<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="
            border-radius: 5px !important;
            padding-left: 0px;
            height: auto !important;
          "
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Email Details</b-navbar-brand>
          <div>
            <h5 class="text-muted justify-content-center">
              <small>{{ totalRows }} Entries</small>
            </h5>
          </div>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <div class="mt-3">
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table
                  show-empty
                  stacked="md"
                  :items="All_Email_Data_List_data"
                  responsive
                  :fields="Columns"
                  primary-key="common_over_id"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  class="position-relative"
                >
                  <template slot="mail_id" slot-scope="row0">
                    <span>
                      {{ row0.index + 1 + (currentPage - 1) * perPage }}
                    </span>
                  </template>
                  <template slot="type" slot-scope="row9">
                    <b-button
                      style="margin-left: 2px; margin-bottom: 2px; font-size: 0.675rem"
                      size="sm"
                      v-if="
                        row9.item.agentName != '' &&
                        row9.item.agentName != null
                      "
                      @click="ShowMailData(row9.item, 'agentName', row9.item.type+' List')"
                      variant="success"
                      >{{row9.item.type}}</b-button
                    >
                    <span v-else>--</span>
                  </template>
                  <template slot="mail_subject" slot-scope="row1">
                    <span>{{
                      row1.item.mail_subject != "" ? row1.item.mail_subject : "--"
                    }}</span>
                  </template>
                  <template slot="mail_mailbody" slot-scope="row2">
                    <span v-html="row2.item.mail_mailbody">{{
                      row2.item.mail_mailbody
                    }}</span>
                  </template>
                  <template slot="All_CC" slot-scope="row3">
                    <b-button
                      style="margin-left: 2px; margin-bottom: 2px; font-size: 0.675rem"
                      size="sm"
                      v-if="row3.item.mail_to != ''"
                      @click="ShowMailData(row3.item, 'mail_to', 'Mail TO Email List')"
                      variant="success"
                      >TO</b-button
                    >
                    <b-button
                      style="margin-left: 2px; margin-bottom: 2px; font-size: 0.675rem"
                      size="sm"
                      v-if="row3.item.mail_cc != ''"
                      @click="ShowMailData(row3.item, 'mail_cc', 'Mail CC Email List')"
                      variant="success"
                      >CC</b-button
                    >
                    <b-button
                      style="margin-left: 2px; margin-bottom: 2px; font-size: 0.675rem"
                      size="sm"
                      v-if="row3.item.mail_bcc != ''"
                      @click="ShowMailData(row3.item, 'mail_bcc', 'Mail BCC Email List')"
                      variant="success"
                      >BCC</b-button
                    >
                    <b-button
                      style="margin-left: 2px; margin-bottom: 2px; font-size: 0.675rem"
                      size="sm"
                      v-if="
                        row3.item.mail_previousto != '' &&
                        row3.item.mail_previousto != null
                      "
                      @click="ShowMailData(row3.item, 'mail_previousto', 'Mail Previous TO Email List')"
                      variant="success"
                      >Previous To</b-button
                    >
                    <b-button
                      style="margin-left: 2px; margin-bottom: 2px; font-size: 0.675rem"
                      size="sm"
                      v-if="
                        row3.item.mail_previouscc != '' &&
                        row3.item.mail_previouscc != null
                      "
                      @click="ShowMailData(row3.item, 'mail_previouscc', 'Mail Previous CC Email List')"
                      variant="success"
                      >Previous CC</b-button
                    >
                    <b-button
                      style="margin-left: 2px; margin-bottom: 2px; font-size: 0.675rem"
                      size="sm"
                      v-if="
                        row3.item.mail_previousbcc != '' &&
                        row3.item.mail_previousbcc != null
                      "
                      @click="ShowMailData(row3.item, 'mail_previousbcc', 'Mail Previous BCC Email List')"
                      variant="success"
                      >Previous BCC</b-button
                    >
                  </template>
                  <template slot="MailStatus" slot-scope="row22">
                    <h6>
                      <b-badge variant="success" v-if="row22.item.is_email_send == '1'">{{
                        row22.item.MailStatus
                      }}</b-badge>
                      <b-badge v-else variant="danger">{{
                        row22.item.MailStatus
                      }}</b-badge>
                    </h6>
                  </template>
                  <template slot="username" slot-scope="row24">
                    <span>{{ row24.item.username }}</span>
                  </template>
                  <template slot="mail_doc" slot-scope="row5">
                    <span
                      v-for="(mail_doc, doc_index) in row5.item.mail_doc.split(',')"
                      :key="doc_index"
                    >
                      <b-button
                        style="margin-left: 2px; margin-bottom: 2px; font-size: 0.675rem"
                        v-if="mail_doc != ''"
                        @click="PrintEmail_Doc(mail_doc)"
                        size="sm"
                        variant="success"
                        >View Doc {{ doc_index + 1 }}
                      </b-button>
                    </span>
                  </template>
                  <template slot="created_at" slot-scope="row24">
                    <span>{{ row24.item.created_at | moment }}</span>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination
                    limit="5"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0 pull-right"
                  />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <!-- Shreshth Gahlot Modal Start -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="EmailList-modal"
      hide-footer
      :title="'All ' + mailDetails.title"
    >
      {{ mailDetails[mailDetails.viewType] }}
      <!-- <b-table
            show-empty
            stacked="md" 
            :items="EmailDataList"
            :fields="EmailField"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
          >
            <template slot="mail_id" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="EmailId" slot-scope="row1">
              <span>
                {{ row1.item.Emails }}
              </span>
            </template>
          </b-table> -->

      <b-row class="mt-2">
        <b-col class="text-center">
          <b-button variant="outline-danger" @click="hideMailData">Close</b-button>
        </b-col>
        <!-- <b-col cols="5"></b-col> -->
      </b-row>
    </b-modal>
    <!-- Shreshth Gahlot Modal End -->
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect, MultiSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import ClientUserService from "../../services/ClientUserService.js";
export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/EmailDetails");
      if (globalPermissionStatus("Dashboard_Access")) {
        this.getAllEmailDataMasterList();
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
    this.$store.dispatch(
      "common/setAllDocumentTypeList",
      JSON.stringify({
        itemCode: "DocumentTypeList",
      })
    );
  },
  data() {
    return {
      ExcelBtnName: "Export As Excel",
      addEditCard: false,
      isLoading: false,
      selectDateFormat,
      EmailField: [
        {
          key: "mail_id",
          label: "SN",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "EmailId",
          label: "Emails",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      Columns: [
        {
          key: "mail_id",
          label: "SN",
          sortable: true,
          sortDirection: "desc",
        },
          {
          key: "type",
          label: "Email Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "mail_subject",
          label: "Email Subject",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "mail_mailbody",
          label: "Email Body",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "All_CC",
          label: "All Email CC/BCC",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "MailStatus",
          label: "Email Status",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "username",
          label: "Mail Sent By",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "mail_doc",
          label: "Mail Document",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "created_at",
          label: "Mail Sent Date",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      docURL: URL_BASE_DOC,
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      sortBy: null,
      sortDesc: false,
      pageOptions: [5, 10, 15],
      adminToggle: this.$sessionsStorage.get(),
      sortDirection: "desc",
      filter: null,
      changePageFilter: "0",
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      mailDetails: {
        mail_to: "",
        mail_cc: "",
        mail_bcc: "",
        mail_previousto: "",
        mail_previouscc: "",
        mail_previousbcc: "",
        agentName: "",
        title: "",
        mailTypeVal: "previousto",
        viewType: "",
      },
      EmailDataList: [],
      All_Email_Data_List_data: [],
      validate: true,
      visible: false,
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    ClientUserService,
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.Columns.filter((f) => f.sortable).map((f) => {
        return { text: f.label, value: f.key };
      });
    },
  },
  methods: {
    PrintEmail_Doc(validity_doc) {
      //console.log("Shreshth Gahlot => ", pridel_doc);
      window.open(
        `${this.docURL}/ASSIGNMENT_UPLOADS/Console_Booking_Doc` + "/" + validity_doc
      );
    },
    getAllEmailDataMasterList() {
      this.isLoading = true;
      let payload = {
        itemCode: "getAllEmailDetails",
      };
      console.log("Shreshth Gahlot Payload => ", payload);
      ClientUserService.getAllOverseaLock(payload)
        .then((response) => {
          console.log("Shreshth Gahlot response => ", response);
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.All_Email_Data_List_data = data.EmailDataList;
            this.totalRows = data.EmailDataList.length;
            console.log(" All_Email_Data_List response=>", data);
          } else {
            this.All_Email_Data_List_data = [];
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on All_Email_Data_List Error: ", error);
        });
    },
    previousSalesView() {
      window.history.go(-1);
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllEmailDataMasterList();
      }, 1000);
    },
    setFocus: function () {
      // Note, you need to add a ref="search" attribute to your input.
      this.$refs.search.focus();
    },
    ShowMailData(item, type, title) {
      this.mailDetails[type] = item[type];
      this.mailDetails.viewType = type;
      this.mailDetails.title = title;

      this.$refs["EmailList-modal"].show();
    },
    hideMailData() {
      this.$refs["EmailList-modal"].hide();
      this.isLoading = false;
    },
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// email-details.vue?14202efc